import styled from "styled-components";

export const WrapperStyled = styled.section`
  display: flex;
  justify-content: center;
  @media (min-width: 680px) {
    justify-content: flex-end;
  }
`;

export const LinkStyled = styled.a`
  font-weight: 700;
  text-decoration: underline;
  margin-left: 5px;
  cursor: pointer;
`;

export const SpanStyledContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const SpanStyled = styled.span`
  font-size: 16px;
  color: #2863d0;
`;
